<template>
  <div class="caseContent">
    <div class="list">
      <ul>
        <li v-for="item in cases">
          <router-link :to="'/raw_detail?id=' + item.id">
            <div class="widthBox">
              <div class="pic">
                <img :src="item.back_img" alt="" />
              </div>
              <div class="cont">
                <h4>{{ item.title }}</h4>
                <div class="botBox">
                  <router-link
                    class="more color"
                    :to="'/raw_detail?id=' + item.id"
                    >Learn more
                  </router-link>
                </div>
                <div class="info">{{ item.describe }}</div>
              </div>
            </div>
          </router-link>
        </li>
      </ul>
    </div>
    <el-pagination
      v-if="total > pageSize"
      :page-size="pageSize"
      :current-page="page"
      @current-change="joinChange"
      layout="prev, pager, next"
      :total="total"
    ></el-pagination>
  </div>
</template>

<script>
import banner from "@/components/banner.vue";
import bannerA from "@/components/bannerA.vue";
import titleOne from "@/components/titleOne.vue";
export default {
  name: "case",
  components: {
    banner,
    titleOne,
    bannerA,
  },
  computed: {
    bannerS() {
      return this.$store.state.bannerS;
    },
  },
  data: function () {
    return {
      caseSharing: {},
      cases: [],
      total: 0,
      page: 1,
      pageSize: 10,
      mobile: false,
    };
  },
  created() {
    var width = document.body.clientWidth;
    if (width <= 768) {
      this.mobile = true;
    }
    this.$api.get("home/index/rawmaterialslist", {
        page: this.page,
        pageSize: this.pageSize,
      })
      .then((res) => {
        this.caseSharing = res.data;
      });
    this.getData();
  },
  mounted() {
    this.$nextTick(function () {
      if (this.$route.query.to != undefined || this.$route.query.to != null) {
        setTimeout(() => {
          document.getElementById(this.$route.query.to).scrollIntoView();
        }, 500);
      } else {
        document.body.scrollIntoView();
      }
    });
  },
  methods: {
    getData() {
      this.$api
        .post("home/index/moreCases", {
          page: this.page,
          pageSize: this.pageSize,
        })
        .then((res) => {
          this.cases = res.data.more_cases;
          this.total = res.data.total;
        });
    },
    joinChange(e) {
      this.page = e;
      this.getData();
    },
  },
};
</script>

<style lang="scss">
$fontcolor: #777;
.caseContent {
  .el-pagination {
    margin: 50px auto 0;
    text-align: center;
    button {
      line-height: 40px;
      height: 40px;
      padding: 0 8px;
      font-weight: 500;
      background-color: #777;
      color: #fff;
      &:hover {
        background: #e11;
      }
      i {
        font-size: 24px;
      }
      &:disabled {
        color: #777;
        background-color: rgba($color: #777, $alpha: 0.1);
        cursor: not-allowed;
      }
    }
    li {
      line-height: 40px;
      height: 40px;
      padding: 0 8px;
      font-size: 24px;
      margin: 0 5px;
      font-weight: 500;
      color: rgba($color: #777, $alpha: 0.4);
      &.active {
        color: rgba($color: #777, $alpha: 1);
      }
    }
  }

  .list {
    li {
      position: relative;
      padding: 50px 0;
      &::before {
        content: "";
        display: block;
        width: 100%;
        height: 40%;
        background: rgba($color: $fontcolor, $alpha: 0.05);
        position: absolute;
        left: 0;
        bottom: 0;
      }
      &::after {
        content: "";
        display: block;
        width: 0;
        height: 0;
        clear: both;
        overflow: hidden;
      }
      .pic {
        width: 680px;
        float: left;
        img {
          width: 100%;
          height: 400px;
        }
      }
      .cont {
        margin-left: 750px;
        padding-top: 80px;
        color: $fontcolor;
        h4 {
          font-size: 30px;
        }
        p {
          font-size: 24px;
          margin-top: 20px;
        }

        .botBox {
          margin-top: 20px;
          .more {
            display: inline-block;
            width: 160px;
            height: 40px;
            text-align: center;
            line-height: 40px;
            font-size: 18px;
            position: relative;
            border: 1px solid $fontcolor;
            .icon {
              position: absolute;
              top: 50%;
              right: -54px;
              width: 77px;
              transform: translate(0, -50%);
            }
          }
        }
        .info {
          font-size: 18px;
          line-height: 32px;
          margin-top: 80px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 4;
        }
      }

      &:hover {
        .cont {
          color: #e11111;
        }
        .botBox {
          .more {
            border-color: #e11111;
            color: #e11111;
          }
        }
      }
    }
  }
}

@media screen and(max-width:1400px) {
  .caseContent {
    .list {
      li {
        .pic {
          width: 500px;
          video {
            height: 350px;
          }
        }
        .cont {
          margin-left: 550px;
        }
      }
    }
  }
}
@media screen and(max-width:1200px) {
  .caseContent {
    .list {
      li {
        &::before {
          height: 50%;
        }
        .pic {
          width: 450px;
          video {
            height: 350px;
          }
        }
        .cont {
          padding-top: 50px;
          margin-left: 500px;
        }
      }
    }
  }
}
</style>
